import { render, staticRenderFns } from "./AuthorizationTabs.vue?vue&type=template&id=1af59208&scoped=true"
import script from "./AuthorizationTabs.vue?vue&type=script&lang=js"
export * from "./AuthorizationTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af59208",
  null
  
)

export default component.exports